import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import CutomBatteryTab from "./CutomBatteryTab";

function CustomQueries () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <CutomBatteryTab />
      <Footer />
    </DashboardLayout>
  );
}

export default CustomQueries;
